import { render, staticRenderFns } from "./eligibility.vue?vue&type=template&id=34dc7e24&scoped=true&lang=pug&"
import script from "./eligibility.vue?vue&type=script&lang=js&"
export * from "./eligibility.vue?vue&type=script&lang=js&"
import style0 from "./eligibility.vue?vue&type=style&index=0&id=34dc7e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc7e24",
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/banking/currents?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230331143208%2Fcomponents%2Fproducts%2Fcurrents%2Feligibility.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/widgets/list-item.vue').default})
